/**
 * Mic acquisition — the ONLY getUserMedia call site in the codebase. Every
 * STT engine (whisper today, a server/WebRTC engine tomorrow) receives the
 * MediaStream from here; permission UX stays on the embedding page's origin
 * (same as the legacy SpeechRecognition behavior).
 */

export type MicResult =
  | { ok: true; stream: MediaStream }
  | { ok: false; reason: "unsupported" | "denied" | "failed" };

export async function acquireMic(): Promise<MicResult> {
  if (typeof navigator === "undefined" || !navigator.mediaDevices?.getUserMedia) {
    return { ok: false, reason: "unsupported" };
  }
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: {
        channelCount: 1,
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: true,
      },
    });
    return { ok: true, stream };
  } catch (err) {
    const name = err instanceof DOMException ? err.name : "";
    if (name === "NotAllowedError" || name === "SecurityError") {
      return { ok: false, reason: "denied" };
    }
    return { ok: false, reason: "failed" };
  }
}

export function releaseMic(stream: MediaStream): void {
  for (const track of stream.getTracks()) {
    try {
      track.stop();
    } catch {
      /* ignore */
    }
  }
}
